<template>
  <div>
    <div class="pb-4 border-b border-brand-grayblue-300 flex flex-col gap-y-3">
      <div class="w-full h-6 rounded-full bg-gray-200"></div>
      <div class="w-[80%] h-6 rounded-full bg-gray-200"></div>
    </div>
    <div class="flex flex-wrap flex-col md:flex-row gap-4 md:gap-12 pt-6">
      <div class="flex-1 flex flex-col gap-y-4">
        <div class="w-full h-6 rounded-full bg-gray-200"></div>
        <div class="my-1 border-b border-brand-grayblue-300"></div>
        <div class="flex flex-col gap-y-2">
          <div class="w-full h-4 rounded-full bg-gray-200"></div>
          <div class="w-full h-4 rounded-full bg-gray-200"></div>
          <div class="w-full h-4 rounded-full bg-gray-200"></div>
          <div class="w-[89%] h-4 rounded-full bg-gray-200"></div>
        </div>
      </div>
      <div class="w-full md:w-1/4">
        <button
          class="w-full py-2 rounded border border-brand-gray-600 bg-brand-gray-300 shadow-md"
        >
          {{ $t('serviceCard') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup></script>

<style lang="scss" scoped></style>
